export default "__VITE_ASSET__BKnp2F6S__"